/**
 * Remove favoritos via AJAX (endpoint do plugin YITH WCWL),
 * sem recarregar a página.
 */
function initRemoveFromWishlist() {
  jQuery(document).on(
    "click",
    ".js-remove-from-wishlist",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $link = jQuery(this);
      const productId = parseInt($link.data("product-id"), 10) || 0;
      const wishlistItemId =
        parseInt($link.data("wishlist-item-id"), 10) || 0;
      const wishlistId = parseInt($link.data("wishlist-id"), 10) || 0;

      if (!productId && !wishlistItemId) return;

      // Extrai o nonce da URL original (gerada pelo get_remove_url)
      const href = $link.attr("href") || "";
      const nonceMatch = href.match(/[?&]_wpnonce=([a-z0-9]+)/i);
      const nonce = nonceMatch ? nonceMatch[1] : "";

      const ajaxUrl =
        (window.yith_wcwl_l10n && window.yith_wcwl_l10n.ajax_url) ||
        (window.wc_add_to_cart_params &&
          window.wc_add_to_cart_params.ajax_url) ||
        "/wp-admin/admin-ajax.php";

      $link.addClass("opacity-50 pointer-events-none");

      const onSuccess = () => {
        const $card = $link.closest(".js-product-card");
        if ($card.length) {
          $card
            .css({ transition: "opacity .2s, transform .2s" })
            .css({ opacity: 0, transform: "scale(0.96)" });
          setTimeout(function () {
            $card.remove();
            checkEmptyWishlist();
          }, 220);
        } else {
          checkEmptyWishlist();
        }
        if (window.Toast && typeof window.Toast.success === "function") {
          window.Toast.success("Removido dos favoritos");
        }
      };

      const onFailure = () => {
        $link.removeClass("opacity-50 pointer-events-none");
        if (window.Toast && typeof window.Toast.error === "function") {
          window.Toast.error("Não foi possível remover. Tente novamente.");
        }
      };

      // 1ª tentativa: endpoint nativo do YITH (action yith_wcwl_remove_from_wishlist)
      jQuery
        .ajax({
          type: "POST",
          url: ajaxUrl,
          data: {
            action: "yith_wcwl_remove_from_wishlist",
            remove_from_wishlist: productId,
            wishlist_id: wishlistId,
            context: "frontend",
            wcwl_nonce: nonce,
            _wpnonce: nonce,
          },
        })
        .done(function (resp) {
          // YITH às vezes responde 200 com {result:'error', message:'nonce'}
          if (resp && resp.result === "error") {
            return fallbackToHrefRedirect();
          }
          onSuccess();
        })
        .fail(function () {
          // Fallback: deixa o YITH processar via reload com query string original
          fallbackToHrefRedirect();
        });

      function fallbackToHrefRedirect() {
        // O href original (?remove_from_wishlist=ID&_wpnonce=...) é processado
        // pelo plugin no carregamento da página — funciona, só recarrega.
        if (href) {
          window.location.href = href;
        } else {
          onFailure();
        }
      }
    }
  );
}

/**
 * Se não restou nenhum card de produto na wishlist, recarrega a página
 * para que o template renderize o estado vazio do `wishlist-view.php`.
 */
function checkEmptyWishlist() {
  const $grid = jQuery(".js-product-card");
  if ($grid.length === 0 && /\/meus-favoritos/.test(window.location.pathname)) {
    window.location.reload();
  }
}

export { initRemoveFromWishlist };
